// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_8PA","cls2":"SingularMentionCitationModal-cls2_62l SingularMentionCitationModal-cls1_8PA"};